module.exports = __webpack_public_path__ + "static/media/team_2.d3ceb2aa.png";